/* BagWise storefront — vanilla JS only */
(function () {
  'use strict';

  /* ---------- Reveal-on-scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Visual filter chips ---------- */
  function initFilters() {
    document.querySelectorAll('[data-filter-group]').forEach(function (group) {
      group.querySelectorAll('.filter').forEach(function (f) {
        f.addEventListener('click', function () {
          group.querySelectorAll('.filter').forEach(function (x) { x.classList.remove('active'); });
          f.classList.add('active');
        });
      });
    });
  }

  /* ---------- DOM helper (no innerHTML on untrusted data) ---------- */
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') node.className = attrs[k];
      else if (k === 'text') node.textContent = attrs[k];
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) {
      if (c == null) return;
      node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return node;
  }

  /* ---------- Cart drawer ---------- */
  var drawer, overlay;
  function openCart() {
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function initDrawer() {
    drawer = document.querySelector('[data-cart-drawer]');
    overlay = document.querySelector('[data-cart-overlay]');
    document.querySelectorAll('[data-cart-open]').forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); closeCart(); });
    });
    if (overlay) overlay.addEventListener('click', closeCart);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  }

  /* ---------- Cart AJAX ---------- */
  var _moneyFmt;
  function money(cents) {
    if (_moneyFmt === undefined) {
      try {
        _moneyFmt = new Intl.NumberFormat(document.body.getAttribute('data-locale') || 'nl-NL', {
          style: 'currency',
          currency: document.body.getAttribute('data-currency') || 'EUR'
        });
      } catch (e) { _moneyFmt = null; }
    }
    if (_moneyFmt) return _moneyFmt.format(cents / 100);
    return '€' + (cents / 100).toFixed(2);
  }
  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (n) {
      n.textContent = String(count);
      n.setAttribute('data-count', String(count));
    });
  }
  function buildLine(item) {
    var qtyRow = el('div', { class: 'cart-line-qty' }, [
      el('button', { type: 'button', 'data-qty-change': '', 'data-key': item.key, 'data-delta': '-1', 'aria-label': 'Decrease', text: '−' }),
      el('span', { text: String(item.quantity) }),
      el('button', { type: 'button', 'data-qty-change': '', 'data-key': item.key, 'data-delta': '1', 'aria-label': 'Increase', text: '+' })
    ]);
    var info = el('div', {}, [
      el('div', { class: 'cart-line-title', text: item.product_title }),
      (item.variant_title && item.variant_title !== 'Default Title') ? el('div', { class: 'cart-line-variant', text: item.variant_title }) : null,
      qtyRow,
      el('button', { type: 'button', class: 'cart-line-remove', 'data-qty-change': '', 'data-key': item.key, 'data-set': '0', text: 'Remove' })
    ]);
    return el('div', { class: 'cart-line', 'data-line-key': item.key }, [
      el('img', { src: item.image || '', alt: '' }), info,
      el('div', { class: 'cart-line-price', text: money(item.final_line_price) })
    ]);
  }
  function renderDrawer(cart) {
    updateCount(cart.item_count);
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    var sub = document.querySelector('[data-cart-subtotal]');
    if (!body) return;
    while (body.firstChild) body.removeChild(body.firstChild);
    if (!cart.items || cart.items.length === 0) {
      body.appendChild(el('div', { class: 'cart-empty', text: 'Your bag is empty.' }));
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    cart.items.forEach(function (item) { body.appendChild(buildLine(item)); });
    if (sub) sub.textContent = money(cart.total_price);
    body.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var setQty = btn.getAttribute('data-set');
        if (setQty !== null) { changeLine(key, parseInt(setQty, 10)); }
        else {
          var delta = parseInt(btn.getAttribute('data-delta'), 10);
          var current = parseInt(btn.parentNode.querySelector('span').textContent, 10);
          changeLine(key, Math.max(0, current + delta));
        }
      });
    });
  }
  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderDrawer(cart); return cart; })
      .catch(function () {});
  }
  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderDrawer(cart); });
  }
  function initAjaxAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (form.hasAttribute('data-no-ajax')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { openCart(); })
        .catch(function () { form.setAttribute('data-no-ajax', ''); form.submit(); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  /* ---------- Wishlist (visual, localStorage) ---------- */
  function initWishlist() {
    var KEY = 'bagwise_wishlist';
    var saved;
    try { saved = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { saved = []; }
    function persist() { try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) {} }
    document.querySelectorAll('[data-wishlist]').forEach(function (h) {
      var id = h.getAttribute('data-wishlist');
      if (saved.indexOf(id) !== -1) h.classList.add('on');
      h.addEventListener('click', function (e) {
        e.preventDefault();
        var i = saved.indexOf(id);
        if (i === -1) { saved.push(id); h.classList.add('on'); }
        else { saved.splice(i, 1); h.classList.remove('on'); }
        persist();
      });
    });
  }

  /* ---------- PDP variant + gallery ---------- */
  function initPDP() {
    var pdp = document.querySelector('[data-pdp]');
    if (!pdp) return;
    var dataEl = pdp.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var first = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    var selected = (product.options || []).map(function (_, i) { return first.options[i]; });
    function current() { return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); }); }
    function setMainImage(src) {
      var main = pdp.querySelector('[data-pdp-main] img');
      if (!main || !src) return;
      // The main image is rendered with a srcset; a browser picks the shown image
      // from srcset and ignores changes to .src. Clear srcset/sizes so the swap sticks.
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = src;
    }
    function activateThumb(thumb) {
      pdp.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      if (thumb) thumb.classList.add('is-active');
    }
    function showVariantImage(v) {
      if (!v || !v.featured_image || v.featured_image.id == null) return;
      var match = pdp.querySelector('[data-pdp-thumb][data-image-id="' + v.featured_image.id + '"]');
      if (match) {
        setMainImage(match.getAttribute('data-full'));
        activateThumb(match);
      } else {
        setMainImage(v.featured_image.src);
      }
    }
    function refresh() {
      var v = current();
      var addBtn = pdp.querySelector('[data-add-btn]');
      var priceEl = pdp.querySelector('[data-pdp-price]');
      var idInput = pdp.querySelector('[name="id"]');
      if (v) {
        if (idInput) idInput.value = v.id;
        showVariantImage(v);
        if (priceEl) {
          while (priceEl.firstChild) priceEl.removeChild(priceEl.firstChild);
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceEl.appendChild(el('span', { class: 'was', text: money(v.compare_at_price) }));
          }
          priceEl.appendChild(el('span', { class: 'now', text: money(v.price) }));
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? addBtn.getAttribute('data-add-text') : addBtn.getAttribute('data-sold-text');
        }
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-unavailable-text') || 'Unavailable';
      }
    }
    pdp.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        selected[idx] = btn.getAttribute('data-option-value');
        pdp.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        refresh();
      });
    });
    pdp.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setMainImage(thumb.getAttribute('data-full'));
        activateThumb(thumb);
      });
    });
    refresh();
  }

  function boot() {
    initReveal(); initFilters(); initDrawer(); initAjaxAdd(); initWishlist(); initPDP(); refreshCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
